export class InfoPersoMin {
    nom: string;
    prenom: string;
}

export class InfoPerso extends InfoPersoMin
{
    genre: string;
    fonction: string;
    service: string;
    email: string;
    telPrincipal: string;
    telSecondaire: string;
    adresse: string;
    complementAdresse: string;
    codePostal: string;
    ville: string;
    pays: string;
    paysLibelle: string;
    roles: string[];
    cguAcceptation: boolean;
    dateAcceptation: string;
    fonctionLibelle: string;
    serviceLibelle: string;
    accountNumber: string;
    jobId: string;
    isMainContact: boolean;
    isBillingContact: boolean;
}
